import React, { useState, useEffect } from 'react';
import {
    Row, Col, Modal, ModalBody, ModalFooter, Button,
    FormGroup
} from 'reactstrap';
import { toast } from 'react-toastify';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import api from '~/services/api';

export default function Address(props) {
    const [show, setShow] = useState(true);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [zipcode, setZipcode] = useState('');

    const maskZipcode = (value) => value.replace(/\D/g, '');

    useEffect(() => {
        if (props?.user?.addresses?.length > 0) {
            const address = props.user.addresses[0];
            setCountry(address.country);
            setState(address.state);
            setCity(address.city);
            setZipcode(maskZipcode(address.zipcode));
        }
    }, [props]);

    const handleUserSubmit = async (event, errors, values) => {
        let toastMessage = ''
        let toastErrorMessage = ''

        values.zipcode = maskZipcode(zipcode);

        try {
            await api.put(`users/${props.user.id}`, { address: values })

            if (props?.user?.addresses?.length > 0) {
                toastMessage = 'Endereço atualizado com sucesso'
                toastErrorMessage = 'Erro ao atualizar endereço'
            } else {
                toastMessage = 'Endereço criado com sucesso'
                toastErrorMessage = 'Erro ao criar endereço'
            }

            toast.success(toastMessage)
            setShow(!show)

            if (props?.user?.addresses?.length > 0) {
                if (props?.searchQuery?.length > 0) {
                    props.handleSetSearchQuery(props?.user?.email)
                    props.handleSearchUser()
                } else {
                    props.loadUsers(props?.selectedPage)
                }
            }
        } catch (error) {
            toast.error(toastErrorMessage || 'Aconteceu um erro ao salvar endereço')
        }
    }

    useEffect(() => {
        api.get('countries')
            .then((response) => {
                setCountries(response.data);
            });

        api.get('states')
            .then((response) => {
                setStates(response.data?.estados);
            });
    }, []);

    const handleSetState = (value) => {
        setState(value);
        setCity(states?.find((item) => item?.sigla === value)?.cidades[0] || '');
    };

    return (
        <Modal style={{ maxWidth: '2600px', width: '70%', maxHeight: '1600px', height: '95%' }} isOpen={show} toggle={() => props.toggle(!show)}>
            <AvForm onSubmit={handleUserSubmit} model={props?.user?.addresses?.length > 0 ? props.user.addresses[0] : {}}>
                <ModalBody>
                    <Row>
                        <Col lg={12}>
                            <AvField style={{}} type="select" label="País" name="country" onChange={e => setCountry(e.target.value)}>
                                <option value="">Selecione</option>
                                {
                                    countries?.map((country) => (
                                        <option key={country?.nome_pais} value={country?.nome_pais}>{country?.nome_pais}</option>
                                    ))
                                }
                            </AvField>

                            <AvField
                                style={{}}
                                label="CEP"
                                placeholder="CEP"
                                name="zipcode"
                                value={zipcode}
                                onChange={e => setZipcode(maskZipcode(e.target.value))}
                                onInput={e => e.target.value = maskZipcode(e.target.value)}
                            />

                            {
                                country === 'Brasil'
                                    ? (
                                        <AvField style={{}} type="select" label="Cidade" name="city" onChange={e => setCity(e.target.value)} value={city}>
                                            <option value="">Selecione</option>
                                            {
                                                states?.find((item) => item?.sigla === state)?.cidades?.map((city) => (
                                                    <option key={city} value={city}>{city}</option>
                                                ))
                                            }
                                        </AvField>
                                    )
                                    : <AvField style={{}} label="Cidade" placeholder="Cidade" name="city" onChange={e => setCity(e.target.value)} />
                            }

                            {
                                country === 'Brasil'
                                    ? (
                                        <AvField style={{}} type="select" label="Estado" name="state" onChange={e => handleSetState(e.target.value)}>
                                            {
                                                states?.map((state) => (
                                                    <option key={state?.sigla} value={state?.sigla}>{state?.nome}</option>
                                                ))
                                            }
                                        </AvField>
                                    )
                                    : <AvField style={{}} label="Estado" placeholder="Estado" name="state" onChange={(e) => handleSetState(e.target.value)} />
                            }

                            <AvField style={{}} label="Rua" placeholder="Ex: avenida,rua..." name="street" />
                            <AvField style={{}} label="Número" placeholder="Número" name="number" />
                            <AvField style={{}} label="Bairro" placeholder="Bairro" name="district" />
                            <AvField style={{}} label="Complemento" placeholder="Complemento" name="complement" />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => props.toggle(!show)}>Cancelar</Button>
                    <FormGroup>
                        <Button color="success" >Salvar e Fechar</Button>
                    </FormGroup>
                </ModalFooter>
            </AvForm>
        </Modal>
    );
}
